import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { cloneDeep, find } from 'lodash';
import moment from 'moment/moment';
import { setBookingCurrentSelection } from '../../data/booking/bookingActions';
import Day from './Day';

class CalendarRoomRow extends React.Component {
  constructor(props) {
    super(props);
    this.bookRoom = this.bookRoom.bind(this);
  }

  render() {
    return (
      <Table.Row key={`room_row_${this.props.room.id}_${this.props.r_i}`} className="room-tr">
        <Table.Cell key={`room_${this.props.room.id}_${this.props.r_i}`} className="room-cell">
          <div className={`room-box label-box${!this.props.room.status ? ' ' : ''}`}>
            <span className="room-name">{this.props.room.name}</span>
            <i className="icon-room icon" />
          </div>
        </Table.Cell>
        {this.renderMonth()}
        <Table.Cell
          key={`emptyKeyRooms_${this.props.room.id}_${this.props.r_i}`}
          className="empty-cell"
        />
      </Table.Row>
    );
  }

  formatBookingDates(bookings) {
    bookings.forEach((booking, d_i) => {
      booking.date = moment(booking.date);
    });
    return bookings;
  }

  bookRoom(day, roomId) {
    // not clickable : do nothing
    if (!day.isClickable) return false;

    const daysSelection = cloneDeep(this.props.currentDaysSelection);

    if (day.isSelected) {
      // remove it from current selection
      const index = daysSelection.rooms.findIndex(
        r => r.date === day.date.unix() && r.id === roomId
      );

      if (index !== 'undefined') {
        daysSelection.rooms.splice(index, 1);
      }
    } else {
      // add it to current selection
      daysSelection.rooms.push({ id: roomId, date: day.date.unix() });
    }
    // update state
    this.props.dispatch(setBookingCurrentSelection(daysSelection));
  }

  renderMonth() {
    // doesn't display out of order status temporary
    this.props.room.status = true;

    const days = [];
    let date = this.props.currentMonth
      .clone()
      .add('w' - 1)
      .startOf('isoWeek');
    for (let i = 0; i < 7 * 7; i++) {
      days.push(
        <Day
          key={date.toString()}
          bookableEntity={this.props.room}
          date={date}
          bookingEntity={this.findBookingForDate(date)}
          showDay={false}
          // clickHandler={this.bookRoom}
          clickHandler={() => {}}
        />
      );

      date = date.clone();
      date.add(1, 'd');
    }

    return days;
  }

  findBookingForDate(date) {
    return find(this.props.room.bookings, booking => {
      return date.isSame(moment(booking.date), 'day');
    });
  }
}

CalendarRoomRow.propTypes = {};

CalendarRoomRow.defaultProps = {};

export default connect(state => ({
  currentMonth: state.projects.single.booking.currentMonth
}))(CalendarRoomRow);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/booking/CalendarRoomRow.js